<template>
  <div id="app">
    <hed />
      <leaveNumer />
    <keep-alive>
      <router-view />
    </keep-alive>
    <fot />
  </div>
</template>

<script>
  import hed from '@/components/heads'
  import fot from '@/components/foot'
  import leaveNumer from '@/components/leaveNumer'
  export default {
    name: 'App',
    data() {
      return {
        all: this.datms
      }
    },
    components: {
      hed,
      fot,
      leaveNumer
    },
    mounted() {
      // this.$nextTick(() => {
      //   new this.$wow.WOW().init();
      // });
    },

    methods: {

    }
  }
</script>

<style>
  @import url("../static/css/app.css");
</style>



// WEBPACK FOOTER //
// src/App.vue